<template>
  <div v-cloak v-if="headerLoaded">
    <div class="vx-row hide-in-print">
      <div class="vx-col w-full mb-6">
        <vs-button
          type="button"
          class="float-left mx-2"
          style="background-color:#444"
          @click.prevent="backToCurrentGrid()"
          >{{ $t("Back") }}</vs-button
        >
      </div>
    </div>
    <div class="vx-card mb-6">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <table class="basic-tbl" id="colored-table">
              <thead>
                <tr>
                  <th style="width: 10%">{{ $t("WarehouseName") }}</th>
                  <th style="width: 15%">{{ $t("Description") }}</th>
                  <th style="width: 10%">{{ $t("OperatorName") }}</th>
                  <th style="width: 13%">{{ $t("Applicant") }}</th>
                  <th style="width: 10%">{{ $t("AutomationCode") }}</th>
                  <th style="width: 10%">{{ $t("ShipmentNumber") }}</th>
                  <th style="width: 10%">{{ $t("CottageNumber") }}</th>
                  <th style="width: 10%">{{ $t("CreateOn") }}</th>
                  <th style="width: 12%">
                    {{ $t("DocumentRegistrationDate") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width: 10%">
                    {{ headerInfo.storeName }}
                  </td>
                  <td style="width: 15%">{{ headerInfo.description }}</td>
                  <td style="width: 10%">
                    {{ headerInfo.inventoryOperatorName }}
                  </td>
                  <td style="width: 13%">
                    {{ headerInfo.inventoryRequesterName }}
                  </td>

                  <td style="width: 10%">
                    {{ headerInfo.automationCode }}
                  </td>
                  <td style="width: 10%; direction: ltr">
                    {{
                      headerInfo.shipmentNumber
                        ? headerInfo.shipmentNumber
                        : "---"
                    }}
                  </td>
                  <td style="width: 10%; direction: ltr">
                    {{
                      headerInfo.cottageNumber
                        ? headerInfo.cottageNumber
                        : "---"
                    }}
                  </td>
                  <td style="width: 12%; direction: ltr">
                    {{ headerInfo.persianDateTime }}
                  </td>
                  <td style="width: 10%; direction: ltr">
                    {{ headerInfo.persianRegisterClock }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-card mt-4">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('ShelveName'), sort: 'ShelveName' },
                { title: $t('ProductName'), sort: 'ProductName' },
                { title: $t('ItemCode'), sort: 'ItemCode' },
                { title: $t('Count'), sort: 'Count' },
                { title: $t('Serial'), sort: 'Serial' }
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 10%">
                  {{ row.shelveName }}
                </td>
                <td
                  style="width: 40%"
                  :class="row.isProcessed ? 'bg-success text-white' : ''"
                >
                  {{ row.stockName }}
                </td>
                <td style="width: 10%">
                  {{ row.itemCode }}
                </td>
                 <td style="width: 10%">
                  {{ row.count }}
                </td>
                <td style="width: 30%">
                  <span>
                    <router-link
                      :to="{
                        path: '/CheckOutForDraftOrder/PrintLabel',
                        query: {
                          transactionId: row.inventoryTransactionId,
                          stockId: row.stockId,
                          basketId: basketId
                        }
                      }"
                    >
                      <vs-button color="primary" type="border" class="view-btn">
                        {{ $t("PrintLabel") }}
                      </vs-button>
                    </router-link>
                  </span>
                  <span>
                    <router-link
                      :to="{
                        path: '/CheckOutForDraftOrder/PrintWarrantyCard',
                        query: {
                          transactionId: row.inventoryTransactionId,
                          stockId: row.stockId,
                          itemCode:row.itemCode,
                          basketId: basketId
                        }
                      }"
                    >
                      <vs-button color="primary" type="border" class="view-btn">
                        {{ $t("PrintWarrantyCard") }}
                      </vs-button>
                    </router-link>
                  </span>
                  <span v-if="row.stockType == 1">
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="custom-border-btn"
                      @click="
                        viewSerials(
                          row.inventoryTransactionId,
                          row.shelveId,
                          row.stockId
                        )
                      "
                      v-has-permission="'GetSerialsOfStock'"
                      >{{ $t("ViewSerials") }}</vs-button
                    >
                  </span>
                  <span v-else>-</span>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
        <div class="vx-col pb-8">
          <vs-button
            @click.prevent="FinishOperationPrintWarrantyCard()"
            v-if="this.type == 'forPrint'"
            class="float-right"
            >{{ $t("FinishOperationPrintWarrantyCard") }}</vs-button
          >
          <vs-button
            @click.prevent="downloadExcel_AllSerials()"
            v-if="this.type == 'forPrint'"
            class="float-right hide-in-print mx-3 bg_l_purple p-3"
            >{{ $t("GetListExcelAllSerial") }}</vs-button
          >
        </div>
      </div>
    </div>
    <serials-list-partial-popup
      :show="SerialsListPopup"
      @finish="onfinish"
      :popupService="popupService"
    ></serials-list-partial-popup>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import SerialsListPartialPopup from "./SerialsListPartialPopup.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "warehouseManagement_CheckOutTransactions_Details",
  components: {
    DataGrid,
    SerialsListPartialPopup
  },
  data() {
    var id = this.$route.params.id;
    return {
      basketId: "",
      model: {},
      gridDataSource: {
        type: "app",
        service: "Inventory/api/InventoryTransactionsQuery/" + id + "/0"
      },
      gridSearchData: {},
      SerialsListPopup: false,
      popupService: "",
      headerLoaded: false
    };
  },
  computed: {
    ...mapGetters({
      headerInfo: "inventoryTransaction/details"
    })
  },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      fetchSingle: "inventoryTransaction/fetchSingle",
      finishPrint: "inventoryTransaction/finishPrint",
      exportExcelAllSerials: "excel/exportExcelAllSerials"
    }),
    load() {
      var id = this.$route.params.id;
      this.type = this.$route.query.type;
      this.basketId = this.$route.query.basketId;
      this.fetchSingle(id).then(() => {
        this.headerLoaded = true;
      });
    },
    PrintTable() {
      window.print();
    },
    downloadExcel_AllSerials() {
      this.exportExcelAllSerials(this.$route.params.id);
    },
    backToCurrentGrid() {
      this.$router.push({
        path: "/CheckOutTransactions/Index",
        query: {
          referencePageInfo: {
            tabIndex: this.$route.query.tabIndex,
            numberRowsPerPage: this.$route.query.numberRowsPerPage
          }
        }
      });
    },
    viewSerials(inventoryTransactionId, shelveId, stockId) {
      this.popupService =
        "/Inventory/api/InventoryTransactionsQuery/serials/" +
        inventoryTransactionId +
        "/" +
        shelveId +
        "/" +
        stockId;
      this.SerialsListPopup = true;
    },
    FinishOperationPrintWarrantyCard() {
      this.model.inventoryTransactionId = this.$route.params.id;
      this.finishPrint(this.model).then(() => {
        setTimeout(() => {
          this.$router.push({
            path: "/CheckOutTransactions/Index",
            query: {
              referencePageInfo: {
                tabIndex: this.$route.query.tabIndex,
                numberRowsPerPage: this.$route.query.numberRowsPerPage
              }
            }
          });
        }, 3000);
      });
    },
    onfinish() {
      this.SerialsListPopup = false;
    }
  }
};
</script>
